/* Suwak przed/po. Cala robota to przepisanie wartosci range do --x;
   przeciaganie palcem, mysza i klawiatura daje natywny <input type=range>.
   Bez tego pliku suwak stoi na 50% i obie kolumny sa czytelne. */
document.querySelectorAll('[data-aiofm-ba]').forEach((ba) => {
  const range = ba.querySelector('[data-aiofm-ba-range]');
  if (!range) return;
  const sync = () => ba.style.setProperty('--x', range.value + '%');
  range.addEventListener('input', sync);
  sync();
});
